import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "@/pages/Home";
import Pricing from "@/pages/Pricing";
import About from "@/pages/About";
import Team from "@/pages/Team";
import Mentorship from "@/pages/Mentorship";
import Testimonials from "@/pages/Testimonials";
import FAQ from "@/pages/FAQ";
import Privacy from "@/pages/Privacy";
import RiskDisclosure from "@/pages/RiskDisclosure";
import ScrollToTop from "@/components/ScrollToTop";

function App() {
  return (
    <div className="App bg-black text-white min-h-screen">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/about" element={<About />} />
          <Route path="/team" element={<Team />} />
          <Route path="/mentorship" element={<Mentorship />} />
          <Route path="/testimonials" element={<Testimonials />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/risk-disclosure" element={<RiskDisclosure />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
